// @flow
import * as React from 'react';

import { Field } from 'redux-form';
import { FormField, FormSelect, FormRadio } from '../../../../components/index';

import { LEAGUE_SIZE } from '../../../../helpers/index';
import { FormDateField } from "../../../../components";
import { getStartDraftDate, league_tooltips } from "../../../../helpers";

type Props = {
	is_draft_commissioner: boolean,
	rounds: Object,
	minDate: string,
	maxDate: string,
	league: {
		status: string,
		draft_status: string,
	}
}

export const LeagueSettings = ({
	rounds,
	minDate,
	maxDate,
	is_draft_commissioner,
	league
}: Props) => (
	<div>
		<Field
			label='Give your Draft League a name*'
			type='text'
			name='name'
			placeholder='League name'
			component={FormField}
			tooltip={league_tooltips.name}
		/>

		<Field
			label='League Size*'
			name='size'
			options={LEAGUE_SIZE}
			component={FormSelect}
			tooltip={league_tooltips.size}
			is_disabled={league.status !== 'scheduled' || league.draft_status !== 'scheduled'}
		/>

		<Field
			label='League Start Round*'
			name='start_round'
			options={rounds}
			component={FormSelect}
			tooltip={league_tooltips.start_round}
			is_disabled={league.status !== 'scheduled'}
		/>

		<FormRadio
			label='Privacy Settings*'
			name='privacy'
			elements={[
				{
					value: 0,
					text: 'Private',
				},
				{
					value: 1,
					text: 'Public',
				}
			]}
			tooltip={league_tooltips.privacy}
			is_disabled={league.status !== 'scheduled' || league.draft_status !== 'scheduled'}
		/>
		<Field
			label='Draft Date & Time'
			type='text'
			name='draft_start'
			placeholder='Draft Date & Time'
			component={FormDateField}
			defaultValue={getStartDraftDate()}
			maxDate={maxDate}
			tooltip={league_tooltips.draft_start}
			is_disabled={league.status !== 'scheduled' || league.draft_status !== 'scheduled'}
		/>
	</div>
);

export default LeagueSettings;


// WEBPACK FOOTER //
// ./src/pages/league/leagueSettings/forms/LeagueSettings.js